import { useState } from "react";
import { Menu } from "semantic-ui-react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { NPShift } from "./Tabs/NPShift/NPShift";
import { Vertices } from "./Tabs/Vertices/Vertices";
import { RAOReport } from "./Tabs/RAOReport/RAOReport";
import { CCValidationRegion } from "./Tabs/CCValidationRegion/CCValidationRegion";
import { AppState } from "../../../store/configureStore";
import { useSelector } from "react-redux";
import { Upload } from "./Tabs/Upload/Upload";
import "./Configurations.css";
import { VerticesFiltering } from "./Tabs/VerticesFiltering/VerticesFiltering";

const menuItems = [
    "CC validation region",
    "NP shift",
    "Vertices Filtering",
    "vertices",
    "reports",
];

export const Configurations = () => {
    const user = useSelector((state: AppState) => state.user);
    const [activeItem, setActiveItem] = useState("CC validation region");

    const handleItemClick = (e: any, data: any) =>
        data.name === "modules selection" || data.name === "merging config"
            ? setActiveItem(activeItem)
            : setActiveItem(data.name);

    return (
        <div id="transition-container-configuration-a" className="calculation-properties transition-container">
            <Menu secondary fluid vertical id="calculation-properties-menu">
                {menuItems.map((name,index) => (
                    <Menu.Item
                        id={`calculation-configuration-properties-menu-item-${index}`}
                        className="calculation-properties-menu-item"
                        key={name}
                        name={name}
                        active={activeItem === name}
                        onClick={handleItemClick}
                    />
                ))}
                {(user.role === "Admin" || user.role === "SuperAdmin") && (
                    <Menu.Item
                        id="calculation-properties-menu-item-configuration-b"
                        className="calculation-properties-menu-item"
                        key="upload"
                        name="upload"
                        active={activeItem === "upload"}
                        onClick={handleItemClick}
                    />
                )}
            </Menu>
            <div id="calculation-properties-content-configuration-c" className="calculation-properties-content">
                <SwitchTransition mode="out-in">
                    <CSSTransition
                        id="fade-configuration-d"
                        key={activeItem}
                        addEndListener={(node, done) => {
                            node.addEventListener("transitionend", done, false);
                        }}
                        classNames="fade"
                        unmountOnExit
                    >
                        {(() => {
                            switch (activeItem) {
                                case "CC validation region":
                                    return <CCValidationRegion />;
                                case "NP shift":
                                    return <NPShift />;
                                case "Vertices Filtering":
                                    return <VerticesFiltering />;
                                case "vertices":
                                    return <Vertices />;
                                case "reports":
                                    return <RAOReport />;
                                case "upload":
                                    return <Upload />;
                                default:
                                    return <></>;
                            }
                        })()}
                    </CSSTransition>
                </SwitchTransition>
            </div>
        </div>
    );
};
